import React, {Component} from "react"

class Title extends Component {
  render() {
    switch(this.props.level){
      case '1':
        return <h1 className={`text-3xl md:text-5xl lg:text-6xl font-bold mb-4 leading-tight ${this.props.className}`} dangerouslySetInnerHTML={{__html:this.props.children}}/>
      case '2':
        return <h2 className={`text-xl md:text-2xl lg:text-4xl font-bold ${this.props.className}`} dangerouslySetInnerHTML={{__html:this.props.children}}/>
      case '3':
        return <h3 className={`text-lg md:text-xl lg:text-2xl font-bold ${this.props.className}`} dangerouslySetInnerHTML={{__html:this.props.children}}/>
      case '4':
        return <h4 className={`text-lg md:text-xl lg:text-2xl font-bold ${this.props.className}`} dangerouslySetInnerHTML={{__html:this.props.children}}/>
      default:
        return <h2 className={`text-xl md:text-2xl lg:text-4xl ${this.props.className}`} dangerouslySetInnerHTML={{__html:this.props.children}}></h2>
    }
  }
}
export default Title
